import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useSnackbar } from '../contexts/SnackbarProvider';
import axiosInstance from '../utils/axiosInstance';
import ClientInfoForm from '../components/ClientInfoForm';
import { Typography, Button, Paper, Stack, Chip } from '@mui/material';
import { PostAdd, Apartment } from '@mui/icons-material';
const ClientNewPage = () => {
    const { showSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const [clientData, setClientData] = useState({
        client_code: '',
        client_name: '',
        branch_name: '',
        client_phone: '',
        client_fax: '',
        industry_id: '',
        business_description: '',
        website_url: '',
        payment_method_id: '',
        payment_terms: '',
        credit_terms: '',
        postal_code: '',
        state: '',
        address_line: '',
    });
    const statusMap = {
        pending: { label: '申請中', color: 'warning' },
        active: { label: '有効', color: 'success' },
    };
    const { register, handleSubmit, control, watch, formState: { errors }, setValue } = useForm({
        defaultValues: clientData,
    });

    // 新規作成ボタンの処理
    const onSubmit = async (data) => {
        try {
            const res = await axiosInstance.post('/client', {
                ...data,
                credit_terms: data.credit_terms ? Number(data.credit_terms) / 100 : null
            });
            navigate(`/clients/${res.data.client_id}`, {
                state: {
                    snackbar: { message: '取引先が作成されました', severity: 'success' }
                }
            });
        } catch (err) {
            if (process.env.NODE_ENV === 'development') console.error(err);
            showSnackbar(err?.response?.data?.message || '登録に失敗しました', 'error');
        }
    };
    return (
        <>
            <Typography variant="h1" component="h1">取引先の作成</Typography>
            {/* 会社情報入力 */}
            <Paper variant='section'>
                <Stack direction="row" alignItems="center" justifyContent='space-between' spacing={1} mb={1}>
                    <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                        <Apartment color="primary" />
                        <Typography component='h2' variant='h4'>会社情報</Typography>
                        <Chip
                            label={statusMap[clientData?.status]?.label || '作成中'}
                            color={statusMap[clientData?.status]?.color || 'warning'}
                        />
                    </Stack>
                </Stack>
                <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
                    <ClientInfoForm
                        clientData={clientData}
                        setClientData={setClientData}
                        register={register}
                        errors={errors}
                        setValue={setValue}
                        control={control}
                        watch={watch}
                        isEditMode={true}
                    />

                    <div className="button-row">
                        <Button
                            type="submit"
                            variant="contained"
                            startIcon={<PostAdd />}
                        >新規作成</Button>
                    </div>
                </form>
            </Paper>
        </>
    );
};
export default ClientNewPage;